export enum StateAbbreviation {
  California = 'CA',
  Louisiana = 'LA',
  Michigan = 'MI',
  Nevada = 'NV',
  Ohio = 'OH',
}

export enum CertificateStatus {
  CURRENT = 'Current',
  EXPIRING = 'Expiring',
  EXPIRED = 'Expired',
  REJECTED = 'Rejected',
  RENEWED = 'Renewed',
  UNTRACKED = 'Untracked',
}

export enum CertificateAttribute {
  certificateId = 'certificateId',
  name = 'name',
  state = 'state',
  status = 'status',
  expirationDate = 'expirationDate',
}

export type TaxExemptionCertificate = {
  [CertificateAttribute.certificateId]: string;
  [CertificateAttribute.name]: string;
  [CertificateAttribute.state]: string;
  [CertificateAttribute.status]: CertificateStatus;
  [CertificateAttribute.expirationDate]: string;
};

export type TExCertificateResponseModel = {
  certificate_id: string;
  name: string;
  state: string;
  status: CertificateStatus;
  expiration_date: string;
};
